import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  BASE_URL,
  GOTOPRODUCTDETAILS_URL_LOCAL,
} from "../../../utility/BaseUrl";
import Swal from "sweetalert2";
import { useState } from "react";
import { addToCartCookie, isTokenValid } from "../../../utility/Cookies";
import AddToCartFunc from "../../../utility/PublicComponent";
import { formatNumber } from "../../../utility/Formater";

const ProductSliderComponentChild = ({ item, setData }) => {
  const [LoadingAddToCart, setLoadingAddToCart] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const {
    product_name,
    slug,
    product_timing_discount,
    id,
    product_cover,
    product_cover_alt,
    product_cover_title,
  } = item.product ?? item;
  let { quantity, color, discount_percent, final_price, product_sales_price } =
    item.inventory_of_product ?? item.product.inventory_of_product;
  // const { image, image_alt, image_title } = item.product.seconde_image??item.seconde_image;

  const addToCard = async () => {
    setLoadingAddToCart(true);
    await AddToCartFunc(id, 1, quantity, null, location, navigate, setData);
    setLoadingAddToCart(false);
  };

  if (item.is_active)
    return (
      <div className="products-item position-relative bg-white rounded p-15 ">
        {discount_percent > 0 ? (
          <span class="products-item-discount">{discount_percent}٪</span>
        ) : null}
        <div className="products-item-image">
          <Link
            to={GOTOPRODUCTDETAILS_URL_LOCAL(slug)}
            className="products-item-link"
          >
            <img
              src={BASE_URL + product_cover}
              title={product_cover_title}
              className="img-fluid center-block products-item-image-element"
              alt={product_cover_alt}
            />
          </Link>
        </div>
        <div className="products-item-price-wrap">
          {discount_percent > 0 ? (
            <span class="products-item-compare-price">
              {formatNumber(product_sales_price)}
            </span>
          ) : null}
          <span className="products-item-price">
            {formatNumber(final_price)}
            <span>تومان</span>
          </span>
        </div>
        <h3 className="products-item-title">
          <Link
            href={GOTOPRODUCTDETAILS_URL_LOCAL(slug)}
            className="products-item-link"
          >
            {product_name}
          </Link>
        </h3>
        <div class="d-flex justify-content-between align-items-center">
          <button
            class="btn product-item-quick-view"
            type="button"
            onClick={LoadingAddToCart ? null : addToCard}
          >
            {/* <svg width="1em" height="1em" viewBox="0 0 16 16" class="" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" d="M3.925 1.745a.636.636 0 0 0-.951-.059l-.97.97c-.453.453-.62 1.095-.421 1.658A16.47 16.47 0 0 0 5.49 10.51a16.471 16.471 0 0 0 6.196 3.907c.563.198 1.205.032 1.658-.421l.97-.97a.636.636 0 0 0-.06-.951l-2.162-1.682a.636.636 0 0 0-.544-.115l-2.052.513a1.636 1.636 0 0 1-1.554-.43L5.64 8.058a1.636 1.636 0 0 1-.43-1.554l.513-2.052a.636.636 0 0 0-.115-.544L3.925 1.745zM2.267.98a1.636 1.636 0 0 1 2.448.153l1.681 2.162c.309.396.418.913.296 1.4l-.513 2.053a.636.636 0 0 0 .167.604L8.65 9.654a.636.636 0 0 0 .604.167l2.052-.513a1.636 1.636 0 0 1 1.401.296l2.162 1.681c.777.604.849 1.753.153 2.448l-.97.97c-.693.693-1.73.998-2.697.658a17.47 17.47 0 0 1-6.571-4.144A17.47 17.47 0 0 1 .639 4.646c-.34-.967-.035-2.004.658-2.698l.97-.969z"/>
      </svg> */}
            {LoadingAddToCart ? (
              <i className="fa fa-refresh fa-spin fa-fw" />
            ) : (
              <svg
                width="1em"
                height="1em"
                viewBox="0 0 16 16"
                class=""
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M0 2.5A.5.5 0 0 1 .5 2H2a.5.5 0 0 1 .485.379L2.89 4H14.5a.5.5 0 0 1 .485.621l-1.5 6A.5.5 0 0 1 13 11H4a.5.5 0 0 1-.485-.379L1.61 3H.5a.5.5 0 0 1-.5-.5zM3.14 5l1.25 5h8.22l1.25-5H3.14zM5 13a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0zm9-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0z"
                />
              </svg>
            )}
          </button>
          {/* <div class="product-rating" eval="collect(152871106, 4.2, 20)" product-rating auto-show>
  <span role="button" class="product-rating-link" ng-click="submit(number)" ng-focus="changeRate(number)" ng-mouseover="changeRate(number)" ng-mouseleave="changeRate()" ng-repeat="number in [1,2,3,4,5]">
      <i class="fa fa-star fa-flip-horizontal text-warning product-rating-link-icon" ng-class="{ 'fa-star-half-o': isHalf(number), 'fa-star-o': model.rate < number }"></i>
  </span>
</div> */}
        </div>
      </div>
    );
};

export default ProductSliderComponentChild;
